// 「刻意整頁導轉」旗標（例：OCEP needBind=1 自動導向綁定頁）。
// 整頁導轉會讓瀏覽器 abort 進行中的 fetch，丟出 Load failed / Failed to fetch /
// AbortError。這是離頁造成的中斷，而非真的網路異常，不應在即將卸載的頁面上閃出
// 錯誤彈窗。導轉前同步呼叫 markIntentionalRedirect()，useClientErrorHandler 據以抑制。
//
// 僅在「當前分頁會實際導走」的路徑標記（window.location.href / replace）；
// 另開視窗（openWindow）不會導走當前頁、請求不會被 abort，切勿標記，否則旗標會
// 永久為真而誤吞後續真正的網路錯誤。
let isRedirecting = false;

export function markIntentionalRedirect() {
    isRedirecting = true;
}

export function isIntentionalRedirecting() {
    return isRedirecting;
}
